var App = App || {};

App.CardCarousel = (function ($) {
    "use strict";

    function init() {
        $(".card-carousel").each(function () {
            var $cardCarousel = $(this);

            if ($cardCarousel.length) {
                $cardCarousel.slick({
                    arrows: true,
                    mobileFirst: true,
                    prevArrow: "<button class='slick-prev' title='Previous slide'><i class='far fa-arrow-left'></i></button>",
                    nextArrow: "<button class='slick-next' title='Next slide'><i class='far fa-arrow-right'></button>",
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2
                        }
                    }],
                    slidesToShow: 1
                });
            }        
        });

        $(".card-carousel__single").each(function () {
            var $cardCarousel = $(this);

            if ($cardCarousel.length) {
                $cardCarousel.slick({
                    arrows: true,
                    mobileFirst: true,
                    prevArrow: "<button class='slick-prev' title='Previous slide'><i class='far fa-angle-left'></i></button>",
                    nextArrow: "<button class='slick-next' title='Next slide'><i class='far fa-angle-right'></button>",
                    slidesToShow: 1
                });
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.CardCarousel.init();
});